import React, { useState } from "react";
import { Card, Button, Row, Col, Tag, Divider, Tooltip } from "antd";
import { CloseCircleOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { AiOutlineClose } from "react-icons/ai";
import BreadCrumb from "../ass_components/BreadCrumb";
import Meta from "../ass_components/Meta";

const initialProducts = [
  {
    id: 1,
    name: "Soja qualité supérieure",
    price: "420 XOF/kg",
    brand: "Terre Nawa",
    type: "Céréale",
    availability: "Disponible",
    color: "Blond Doré",
    sizes: ["25kg", "50kg"],
    origin: "Plateau-Ouest",
    image: "images/detail-images/soja4.jpg",
  },
  {
    id: 2,
    name: "Soja jaune séché",
    price: "315 XOF/kg",
    brand: "AgroSavane",
    type: "Céréale",
    availability: "Stock limité",
    color: "Jaune pâle",
    sizes: ["50kg"],
    origin: "KARA-EST",
    image: "images/detail-images/soja2.jpg",
  },
];

const CompareProducts = () => {
  const [products, setProducts] = useState(initialProducts);

  const removeProduct = (id) => {
    setProducts(products.filter((p) => p.id !== id));
  };

  return (
    <>
      <Meta title={"Comparer Produits"} />
      <BreadCrumb title="COMPARAISON DES PRIX" />

      <div className="compare-product-wrapper assiganto-home-wrapper-2 py-5">
        <div className="container-xxl">
          <Row gutter={[16, 16]}>
            {products.map((product) => (
              <Col xs={24} sm={12} md={8} lg={6} key={product.id}>
                <Card
                  title={
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <span>{product.name}</span>
                      <Tooltip title="Retirer ce produit">
                        <CloseCircleOutlined
                          onClick={() => removeProduct(product.id)}
                          style={{ color: "#f5222d", fontSize: "18px", cursor: "pointer" }}
                        />
                      </Tooltip>
                    </div>
                  }
                  hoverable
                  cover={<img alt={product.name} src={product.image} style={{ height: 180, objectFit: "cover" }} />}
                  bordered
                >
                  <Tag color="green">{product.availability}</Tag>
                  <p><strong>Prix :</strong> {product.price}</p>
                  <p><strong>Origine :</strong> {product.origin}</p>
                  <p><strong>Type :</strong> {product.type}</p>
                  <p><strong>Marque / Coopérative :</strong> {product.brand}</p>
                  <p><strong>Conditionnement :</strong> {product.sizes.join(", ")}</p>
                  <p><strong>Aspect :</strong> {product.color}</p>
                  <Divider />
                  <Button type="link" href={`/products/${product.id}`}>
                    Voir fiche détaillée <InfoCircleOutlined />
                  </Button>
                </Card>
              </Col>
            ))}
            {products.length === 0 && (
              <Col span={24}>
                <div style={{ textAlign: "center", padding: 30 }}>
                  <p>Aucun produit sélectionné pour comparaison.</p>
                  <Button className="application-button" href="/marketplace">Ajouter des produits</Button>
                </div>
              </Col>
            )}
          </Row>
        </div>
      </div>
    </>
  );
};

export default CompareProducts;
